// One import function shared by the route table and the Opportunity page, so both resolve to the
// same chunk and the Opportunity page can start downloading it while the webhook is still pending.
export const loadEmbedTrip = () => import('./EmbedTrip');
